module.exports = __webpack_public_path__ + "static/img/sc1.a2ac55b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc1.png
// module id = +VDI
// module chunks = 25